import styled, { css } from 'styled-components';
import { media, remCalc, layout } from 'src/components/base';
import AdContainerComponent from '../../../../components/ads';

type AdvertProps = {
  withPosition?: boolean;
};

const compensateForPadding = remCalc(layout.gridColumnGutter.small.value / 2);
export const PriceListPanelWrapper = styled.div`
  padding-top: ${layout.measurements.spacing100};
`;

export const AdContainer = styled(AdContainerComponent)`
  @media screen and (max-width: 340px) {
    margin-left: -${compensateForPadding};
    margin-right: -${compensateForPadding};
  }
`;

export const Information = styled.div`
  border-top: 1px solid ${p => p.theme.colors.base200};
  color: ${p => p.theme.colors.base500};
  font-size: ${remCalc(13)};
  font-style: italic;
  padding-top: ${remCalc(10)};
  padding-bottom: ${remCalc(10)};
`;

export const AdvertTableRowElement = styled.div<AdvertProps>`
  width: 100%;
  border-bottom: none;

  ${p =>
    p.withPosition &&
    css`
      order: 3;
    `};
`;

export const PricePanelHeader = styled.span(
  props => css`
    display: flex;
    align-items: center;
    text-transform: none;
    white-space: nowrap;

    ${media.smallOnly`
      display: none;
  `}
  `
);

export const TitleCount = styled.span`
  font-weight: 100;
  font-size: ${layout.measurements.fontSizeSmall};
  margin-left: ${layout.measurements.spacing025};
`;

export const Header = styled.div`
  align-items: center;

  z-index: 3; /* Needed for sorting dropdown */
  margin-top: 0;
  margin-bottom: ${layout.measurements.spacing050};

  ${media.smallOnly`
    grid-template-columns: repeat(2, 1fr);
  `};
`;

export const HeaderButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${layout.measurements.spacing050};

  ${media.mediumUp`
    gap: ${layout.measurements.spacing100};
  `};
`;

export const DisclaimerWrapper = styled.div`
  ${media.smallOnly`
    position: absolute;
    width: calc(100vw - ${remCalc(layout.pageContent.gutter.value * 2)});
  `}
`;

export const HeaderFlex = styled.div`
  display: flex;
  margin-bottom: ${layout.measurements.spacing050};
  align-items: center;
  justify-content: space-between;

  ${media.smallOnly`
    flex-direction: column;
    align-items: flex-start;

    > span {
      margin-top: ${layout.measurements.spacing050};
    }
  `};
`;
